import { AffiliateFirstDepositorReport } from '@core/models/affiliate-first-depositor-report.model';
import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Pagination } from '@core/models/pagination.model';
import { Injectable } from '@angular/core';

@Injectable()
export class AffiliateFirstDepositorReportDataService extends DefaultDataService<AffiliateFirstDepositorReport>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('AffiliateFirstDepositorReport', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<AffiliateFirstDepositorReport[]> {
    return this.http.get<ApiResponse>('/report/affiliatefirstdepositreport?paginate=true').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<AffiliateFirstDepositorReport[]>{
    return this.http.get<ApiResponse>(`/report/affiliatefirstdepositreport?paginate=true${pageParam}`).pipe(
      tap(res => {
        this.paginationInit(res);
      }),
      map(res => res.data.rows)
    );
  }

  exportReport(pageParam: string) {
    return this.http.get<ApiResponse>(`/report/exportaffiliatefirstdepositreport${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res){
      this.pagination = res.data.paginations;
    }
  }
}
